/**
 * OVERRIDE ListingBody.jsx
 * REASON: To implement Pagination Wrapper according to Theme style.
 */

import ListingBody from '../../../../../../components/Blocks/Listing/ListingBody';

export default ListingBody;
